import React, { useState } from 'react';
import AvoirAchatList from '../components/achat/avoir/AvoirAchatList';
import SingleAvoirAchat from '../components/achat/avoir/SingleAvoirAchat';

const AvoirAchatPage = () => {
  const [selectedId, setSelectedId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [mode, setMode] = useState('list');

  const handleSelect = (id) => {
    setSelectedId(id);
    setMode('single');
  };

  const handleClose = () => {
    setSelectedId(null);
    setMode('list');
  };

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      {mode === 'list' && (
        <AvoirAchatList key={refreshKey} onSelect={handleSelect} />
      )}
      {mode === 'single' && selectedId && (
        <SingleAvoirAchat
          id={selectedId}
          onStatusChange={()=> setRefreshKey(v=>v+1)}
          onClose={handleClose}
        />
      )}
    </div>
  );
};

export default AvoirAchatPage;
